/**
 * "Chance only" — the caveat on a trade that cannot promise what it is for.
 *
 * A Lucky or 100% trade is a plan for an OUTCOME, where every other trade row
 * is a plan for an object: Lucky is conferred by the trade rather than carried
 * through it, and the IVs are re-rolled on arrival. See lib/tradeChance.
 *
 * Amber rather than the dex-variant colour, and deliberately NOT the accent:
 * every other chip on these rows says what a thing IS, and this one says what
 * it might not be. It carries the reason as a title so the "why" is one press
 * away without spending a line on every row.
 */
import { isChanceOnlyVariant, chanceOnlyReason } from "@/lib/tradeChance";

export function ChanceOnlyBadge({
  variant,
  className = "",
}: {
  variant: string;
  className?: string;
}) {
  if (!isChanceOnlyVariant(variant)) return null;
  return (
    <span
      className={`shrink-0 inline-flex items-center text-[8px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-full whitespace-nowrap ${className}`}
      style={{
        background: "hsl(43 96% 55% / 0.16)",
        border: "1px solid hsl(43 96% 55% / 0.5)",
        color: "hsl(43 96% 45%)",
      }}
      title={chanceOnlyReason(variant) ?? undefined}
      data-testid={`chance-only-${variant}`}
    >
      Chance only
    </span>
  );
}
